import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export default function ScriptCard({ script, index = 0 }) {
  return (
    <Link
      to={`/scripts/${script.script_id}`}
      data-testid={`script-card-${script.script_id}`}
      className="cw-card rounded-2xl overflow-hidden flex flex-col group"
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={script.thumbnail}
          alt={script.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-black/60 border border-white/10 backdrop-blur">
            {script.platform}
          </span>
        </div>
        <div className="absolute top-3 right-3 text-[10px] px-2 py-1 rounded-full bg-[#FF6B00]/20 border border-[#FF6B00]/40 text-[#FFB07A]">
          {script.duration}
        </div>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="cw-label mb-2">{script.industry}</div>
        <h3 className="font-display text-lg leading-tight mb-2 line-clamp-2 group-hover:text-[#FF6B00] transition-colors">{script.title}</h3>
        <p className="text-sm text-white/60 line-clamp-2 mb-4">{script.hook}</p>
        <div className="mt-auto flex items-center justify-between">
          <div className="flex items-center gap-1 text-white/80 text-sm">
            <Star className="h-4 w-4 fill-[#FF6B00] text-[#FF6B00]" />
            <span>{script.rating || "—"}</span>
            <span className="text-white/40 text-xs">({script.reviews_count || 0})</span>
          </div>
          <div className="text-lg font-display font-semibold">₹{script.price}</div>
        </div>
      </div>
    </Link>
  );
}
